import _memoize from 'lodash/memoize';
import { DEFAULT_MODE } from '@tornado-rdk/theme';
import { Lightning } from '@lightningjs/sdk';
import { getScreenSize } from '../../../utils/sizes';
import { BORDER_WIDTH, INNER_BORDER_COLOR } from '../../../utils/focus';
import { TRANSPARENT } from '../../../utils/colors';
import { BORDER_COLOR } from '../default/focus.style';

export const defaultContext = { screenSize: getScreenSize(), colorMode: DEFAULT_MODE };

export { BORDER_WIDTH };

export const getOuterBorderTexture = _memoize(
  ({ screenSize, colorMode }, radius) => {
    const diameter = radius * 2;

    return Lightning.Tools.getRoundRect(
      diameter,
      diameter,
      radius,
      BORDER_WIDTH[screenSize] / 2,
      BORDER_COLOR[colorMode],
      true,
      TRANSPARENT,
    );
  },
  ({ screenSize, colorMode }, radius) => `${screenSize}_${colorMode}_${radius}`,
);

export const getInnerBorderTexture = _memoize(
  ({ screenSize, colorMode }, radius) => {
    const diameter = radius * 2;
    const borderWidth = BORDER_WIDTH[screenSize] / 2;

    return Lightning.Tools.getRoundRect(
      diameter,
      diameter,
      radius,
      // NOTE: while border width should be equal to 2px, we adding an extra pixel to ensure there will be no gap between image and border
      borderWidth + 1,
      INNER_BORDER_COLOR[colorMode],
      true,
      TRANSPARENT,
    );
  },
  ({ screenSize, colorMode }, radius) => `${screenSize}_${colorMode}_${radius}`,
);

export const getInitialStyle = ({ screenSize } = defaultContext) => {
  const borderWidth = BORDER_WIDTH[screenSize] / 2;

  return {
    Inner: {
      x: borderWidth,
      y: borderWidth,
    },
  };
};
